import React from 'react';
import TextField from '@material-ui/core/TextField';
import ContentLoader from 'react-content-loader';
import { withRouter } from 'react-router-dom';
import { Select, MenuItem } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import Geosuggest from 'react-geosuggest';
import { cookies } from '../../utils/getToken';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import { GOOGLE_MAP_KEY } from '../../utils/config/constants';
let isMounted = false;
let loading = false;
class HomeCaroselParallax extends React.Component {
    constructor(props) {
        super(props);
        var windowScrollTop = window.pageYOffset / 3;
        this.state = {
            transform: 'translate3d(0,' + windowScrollTop + 'px,0)',
            keyword: '',
            city: '',
            category: 'all'
        };
        this.resetTransform = this.resetTransform.bind(this);
    }
    componentDidMount() {
        isMounted = true;
        this.getData();
    }
    componentWillUpdate(prevProps, prevState) {
        if (prevProps.banners)
            if (prevProps.banners.length != this.props.banners.length) {
                loading = true;
            }
    }
    getData = () => {
        if (isMounted) {
            var windowScrollTop = window.pageYOffset / 3;
            this.setState({
                transform: 'translate3d(0,' + windowScrollTop + 'px,0)'
            });
            window.addEventListener('scroll', this.resetTransform);
        }
    };

    componentWillUnmount() {
        isMounted = false;
        window.removeEventListener('scroll', this.resetTransform);
    }
    handleChangeCategory = event => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };
    resetTransform() {
        var windowScrollTop = window.pageYOffset / 3;
        this.setState({
            transform: 'translate3d(0,' + windowScrollTop + 'px,0)'
        });
    }

    renderLoading = index => {
        return (
            <div style={{ width: '1000', height: '400px' }} key={index}>
                <ContentLoader
                    width={1000}
                    height={400}
                    speed={2}
                    primaryColor="#dbd9d9"
                    secondaryColor="#dddddd"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="1000" height="400" />
                </ContentLoader>
            </div>
        );
    };
    getSelectedService = service => {
        if (typeof service != 'undefined') {
            this.setState({ keyword: service.heading, serviceId: service.key });
        }
    };
    searchClicked = () => {
        this.props.history.push({
            pathname: `/provider/list/${
                this.state.keyword ? this.state.keyword : 'none'
            }/${this.state.city ? this.state.city : 'none'}/${
                this.state.category ? this.state.category : 'none'
            }`
        });
    };
    handleSelectPlace = event => {
        if (event) {
            this.setState({ city: event.gmaps.vicinity });
            cookies.set('latitude', event.location.lat, { path: '/' });
            cookies.set('longitude', event.location.lng, { path: '/' });
        }
    };

    render() {
        const { children, banners } = this.props;

        return (
            <div>
                <div className="homeslider-main" >
                    {banners &&
                        banners.map((n, index) => {
                            if (index == 0)
                                return loading ? (
                                    this.renderLoading(index)
                                ) : (
                                    <div key={index}>
                                        <img
                                            className="full-width"
                                            width={'100%'}
                                            height={'100%'}
                                            aria-label="banner-img"
                                            src={n.image.large}
                                        />
                                        <div className="overlay-banner">
                                            <div className="container">
                                                <div className="row align-items-center text-center justify-items-center h-100">
                                                    <div className="col-12 height-auto">
                                                        <h1>{n.title}</h1>
                                                        <h5>{n.description}</h5>
                                                        <form className="cate-search-form">
                                                            <div className="input-field">
                                                                <TextField
                                                                    className="autocomplete select-search"
                                                                    label="Search your services"
                                                                    id="select-search"
                                                                    autoFocus={
                                                                        this
                                                                            .state
                                                                            .focus
                                                                    }
                                                                    autoComplete={
                                                                        false
                                                                    }
                                                                    onChange={event => {
                                                                        this.setState(
                                                                            {
                                                                                keyword:
                                                                                    event
                                                                                        .target
                                                                                        .value
                                                                            }
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="input-field">
                                                                <Geosuggest
                                                                    autoComplete="off"
                                                                    id="select-city"
                                                                    className="autocomplete select-city"
                                                                    suggestItemClassName="autosuggest-places"
                                                                    onSuggestSelect={
                                                                        this
                                                                            .handleSelectPlace
                                                                    }
                                                                    inputClassName={
                                                                        'geosuggest-input'
                                                                    }
                                                                    placeholder="Enter city"
                                                                   
                                                                />
                                                                {/* <TextField
                                                                    className="autocomplete select-city"
                                                                    label="Enter city"
                                                                    id="select-city"
                                                                    autoFocus={
                                                                        this
                                                                            .state
                                                                            .focus
                                                                    }
                                                                    onChange={event => {
                                                                        this.setState(
                                                                            {
                                                                                city:
                                                                                    event
                                                                                        .target
                                                                                        .value
                                                                            }
                                                                        );
                                                                    }}
                                                                /> */}
                                                            </div>
                                                            <div className="input-field">
                                                                <Select
                                                                    className="auto-category select-category"
                                                                    style={{
                                                                        color:
                                                                            '#000000'
                                                                    }}
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .category
                                                                    }
                                                                    onChange={
                                                                        this
                                                                            .handleChangeCategory
                                                                    }
                                                                    name="category"
                                                                >
                                                                    <MenuItem value="all">
                                                                        <FormattedMessage
                                                                            id="allCategories"
                                                                            defaultValue={`All Categories`}
                                                                        />
                                                                    </MenuItem>
                                                                    {this.props.categoryData.map(
                                                                        (
                                                                            category,
                                                                            index
                                                                        ) => {
                                                                            return (
                                                                                <MenuItem
                                                                                    key={
                                                                                        index
                                                                                    }
                                                                                    value={
                                                                                        category.key
                                                                                    }
                                                                                >
                                                                                    {
                                                                                        category.heading
                                                                                    }
                                                                                </MenuItem>
                                                                            );
                                                                        }
                                                                    )}
                                                                </Select>
                                                            </div>
                                                            <div
                                                                className="input-field"
                                                                onClick={
                                                                    this
                                                                        .searchClicked
                                                                }
                                                            >
                                                                <i className="waves-effect waves-light tourz-sear-btn waves-input-wrapper">
                                                                    <input
                                                                        type="submit"
                                                                        value="search"
                                                                        className="waves-effect waves-light tourz-sear-btn"
                                                                    />
                                                                </i>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                        })}
                </div>
                {children}
            </div>
        );
    }
}

export default withRouter(
    GoogleApiWrapper(props => ({
        apiKey: GOOGLE_MAP_KEY
    }))(HomeCaroselParallax)
);



// WEBPACK FOOTER //
// ./src/components/Parallax/HomeCaroselParallax.jsx